import React from "react";
import BasePaywall from "app/components/paywalls/BasePaywall";
import templatesIcon from "app/images/paywall-body-icon-templates.png";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

type PropsDef = {
  show?: boolean;
  onClose?: () => void;
};

export default function TemplatesPaywall({ show, onClose }: PropsDef) {
  const { t } = useTranslation();

  const upperContent = (
    <>
      <h5>{t("Templates Not Enabled")}</h5>
      <p className={styles.description}>
        {t("Upgrade to")}{" "}
        <a href="https://coachnow.io/pro" className={styles.highlight}>
          CoachNow PRO
        </a>{" "}
        {t("to create reusable series of posts for easy Space setup!")}
      </p>
    </>
  );

  return (
    <BasePaywall
      show={show}
      onClose={onClose}
      title="Upgrade to Create a Template"
      image={templatesIcon}
      returnUrl="/space_templates"
      featureName="Templates"
      upperContent={upperContent}
    />
  );
}
